module.exports = __webpack_public_path__ + "static/Layer@2x-fd77438dcfbf3aad60f9eafaceebf8a2.jpg";